import { isRequiredFieldsEmpty, isFindServiceHistoryFormSubmitting } from './components/FindServiceHistoryForm/selectors'

export const isSubmitBtnDisabled = state =>
  isRequiredFieldsEmpty(state) || isFindServiceHistoryFormSubmitting(state)
